<!-- 尺寸 -->
<template>
  <BaseFormItem2
    class="length"
    :unit="fields.unit"
    :label="label"
    :labelTips="fields.labelTips"
    :fillTips="fillTips"
    :isError="isShowErrorSytle"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <BaseInput2
      v-model="val.length"
      :maxlength="5"
      width="65px"
      placeholder="长/x"
      :isError="isError"
      :disabled="disabled"
      @input="val => $emit('update:length', val)"
      @change="() => handleEmitChange('length')"
    ></BaseInput2>
    <span class="length__linker">x</span>
    <BaseInput2
      v-model="val.width"
      :maxlength="5"
      width="65px"
      placeholder="宽/y"
      :isError="isError"
      :disabled="disabled"
      @input="val => $emit('update:width', val)"
      @change="() => handleEmitChange('width')"
    ></BaseInput2>

    <!-- 板子尺寸提示 -->
    <div v-if="sizeTips" slot="extend" class="length__tips">
      {{ sizeTips }}
    </div>
  </BaseFormItem2>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    length: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: [String, Number],
      default: ''
    },
    // 出货形式
    units: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 板子面积提示
    areaTips: {
      type: String,
      default: ''
    },
    // 板子尺寸提示
    sizeTips: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      val: {
        length: this.length,
        width: this.width,
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('length')
    },
    label() {
      return this.units == 3 ? '连片尺寸' : '单片尺寸'
    },
    // 是否显示未填写样式
    fillTips() {
      const { length, width } = this.val
      return !length && !width
    },
    isShowErrorSytle() {
      return this.isError || !!this.areaTips || !!this.sizeTips
    }
  },
  watch: {
    length(length) {
      this.val.length = length
      this.isShowError(false)
    },
    width(width) {
      this.val.width = width
      this.isShowError(false)
    }
  },
  methods: {
    handleEmit(key) {
      this.$emit(`update:${key}`, this.val[key])
      this.isShowError(false)
    },
    handleEmitChange(key) {
      let val = parseFloat(this.val[key])
      if (isNaN(val)) {
        val = ''
      } else {
        val = Math.round(val * 100) / 100
      }
      this.val[key] = val
      this.handleEmit(key)
      this.$emit('change', { ...this.val })
      this.isShowError(false)
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
.length {
  .length__linker {
    margin: 0 8px;
    color: #BBBBBB;
  }
  ::v-deep .base-form-item__content {
    &.fill-tips,
    &.is-error {
      padding-right: 15px;
    }
  }
  .length__tips {
    width: 100%;
    color: $--color-danger;
  }
}
</style>